import styled, { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle `
  :root {
    --cream: hsl(30, 38%, 92%);
    --dark-cyan: hsl(158, 36%, 37%);
    --dark-grayish-blue: hsl(228, 12%, 48%);
    --font-size: 14px;
    --very-dark-blue: hsl(212, 21%, 14%);
    --white: hsl(0, 0%, 100%);
  }

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html {
    color: var(--very-dark-blue);
    font-family: 'Montserrat', sans-serif;
    font-size: var(--font-size);
  }

`

const Main = styled.main`
  align-items: center;
  background-color: var(--cream);
  display: flex;
  height: 100vh;
  justify-content: center;
  width: 100vw;
`

const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  height: max-content;
  padding: 1rem 1rem;
  justify-content: center;
  width: 100%;
`

const Foto = styled.div`
  height: 300px;
  width: 400px;
  
  picture {
    display: block;
    height: 100%;
    width: 100%;
    
    img {
      border-radius: 15px 15px 0 0;
      height: 100%;
      width: 100%;
      object-fit: cover;
      transition: all .3s ease-in-out;
    }

    img:hover {
      content: url(image-product-mobile-hover.jpg);
      filter: contrast(1.2);
    }
  }

  @media (width >= 828px) { 
    height: 495px;

    picture{
      img {
        border-radius: 15px 0 0 15px;
      }

      img:hover {
        content: url(image-product-desktop-hover.jpg);
      }
    }
  }
`

const Descricao = styled.div`
  align-items: flex-start;
  background-color: white;
  border-radius: 0 0 15px 15px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: center;
  padding: 2rem 1.5rem;
  width: 400px;

  h1 {
    color: var(--dark-cyan);
    font-size: 1.2rem;
    font-weight: 500;
    letter-spacing: 2px;
    text-transform: uppercase;
  }

  h2 {
    font-family: 'Fraunces', serif;
    font-size: 2.2rem;
    line-height: 2.2rem;
  }

  p {
    color: var(--dark-grayish-blue);
    font-size: 1rem;
    width: 95%;
    font-size: .9rem;
    line-height: 1.3rem;
  }

  .container {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 1.5rem;
    margin-top: 3rem;
    width: 100%;
  }

  .price {
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 1.6rem;
    justify-content: flex-start;

    span {
      color: var(--dark-cyan);
      font-family: 'Fraunces', serif;
      font-size: 2rem;
      font-weight: 700;
    }

    span:last-of-type {
      color: var(--dark-grayish-blue);
      font-family: inherit;
      font-size: .8rem;
      font-weight: 400;
      text-decoration: line-through;
    }

    span::before {
      content: '$';
    }
  }

  button {
    align-items: center;
    background-color: var(--dark-cyan);
    border-radius: 5px;
    border: none;
    color: var(--white);
    cursor: pointer;
    display: flex;
    font-family: inherit;
    font-size: 1rem;
    font-weight: 500;
    justify-content: center;
    padding: 1rem;
    transition: all .3s ease-in-out;
    width: 100%;
    overflow: hidden;
    position: relative;

    span {
      position: absolute;
      left: 5rem;

    }

    &.active span {
      animation: button 2s ease-in-out forwards;
    }
  }

  .carrinho {
    margin-right: .5rem;
  }
  
  @keyframes button {
    0% {
      transform: rotate(0) translateX(-30) translateY(0);
    }

    15% {
      transform: rotate(0) translateX(-10px) translateY(5px);
    }

    30% {
      transform: rotate(-15deg) translateX(10px) translateY(-10px);
    }

    100% {
      transform: rotate(0) translateX(-10rem) translateY(0);
    }
  }

  @media screen and (width >= 828px) {
    height: 495px;
    width: 370px;
    border-radius: 0 15px 15px 0;
    padding: 3rem 2.5rem;
    justify-content: flex-start;
    gap: 1.5rem;
  
    h2 {
      font-size: 2.7rem;
      line-height: 2.5rem;
    }

    p {
      font-size: 1.2rem;
      line-height: 1.7rem;
    }

    .container {
      margin-top: 1rem;
    }

    .price {
      span {
        font-size: 2.5rem;
      }
    }

    button {
      font-size: 1.2rem;
    }
  }
`

export const styleds = {
  Main,
  Container,
  Foto,
  Descricao,
  GlobalStyle,
}

export default styleds